import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/authHelpers";
import ChangePasswordForm from "../Konfigurimet/Profile/ChangePasswordForm";
import {
  getAuthIdentityId,
  isForceResetRequired,
} from "../../utils/forceReset";
import "./auth-scss/forgotPassword.scss";

function ResetPassword() {
  const auth = useAuth();
  const navigate = useNavigate();
  const authReady = !!getAuthIdentityId(auth);
  const mustReset = isForceResetRequired(auth);

  useEffect(() => {
    // Wait until user record is loaded — don't bounce to dashboard early
    // (that was letting forced-reset users into the app).
    if (!authReady) return;
    if (!mustReset) {
      navigate("/kryefaqja", { replace: true });
    }
  }, [authReady, mustReset, navigate]);

  if (!authReady || !mustReset) {
    return <div className="forgot-password" />;
  }

  return (
    <div className="forgot-password">
      <div className="login-form" style={{ maxWidth: 420, width: "100%" }}>
        <ChangePasswordForm
          mode="forced"
          onSuccess={() => navigate("/kryefaqja", { replace: true })}
        />
      </div>
    </div>
  );
}

export default ResetPassword;
